"use client";
import {useState} from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function NewNewsletterForm(){
    const [email, setEmail] = useState("");

    function subscribeNewsletter(e){
        e.preventDefault();

        axios.post('/api/newsletter', {email})
        .then(res => toast.success("Félicitation vous êtes maintenant abonné"))
        .catch(err => toast.error("Une erreur s'est produite"))
        .finally(() => setEmail(""))
    }

    return(
        <form className={"flex flex-col sm:flex-row gap-3 sm:gap-x-4"} onSubmit={subscribeNewsletter}>
            <input
                type={"email"}
                placeholder={"Votre adresse email"}
                className={"px-4 py-3 rounded-lg border border-[#E0E0E0] flex-1 w-full"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <button className={"px-6 md:px-8 py-3 md:py-4 rounded-lg bg-primary hover:bg-[#D1A400] text-white font-semibold whitespace-nowrap"}>
                S&apos;abonner
            </button>
        </form>
    )
}